(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodScriptLoader', sodScriptLoader);

    function sodScriptLoader() {
        return {
            restrict: 'E',
            scope: { content: '=?', src: '=?', attrib: '=?' },
            controller: sodScriptLoaderCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodScriptLoaderCtrl($scope) {
        var vm = this;

        this.$onInit = function() {
            if (vm.content || vm.src) {
                var id = randomString(16);
                $scope.$on('$destroy', function () {
                    $('script#' + id).remove();
                });
            }

            if (vm.content) {
                $('<script id="' + id + '">').html(vm.content).appendTo('body');
            }

            if (vm.src) {
                $('<script id="' + id + '" src="' + vm.src + '" ' + (vm.attrib || '') + '>').appendTo('body');
            }
        }

        function randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        }
    }
})();